import bigImg from "../../../assets/bid-img.svg";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import UploadProjectRequestModal from "../../Model/UploadProjectRequestModal";
import SelectDesignBuildCategoryModal from "../../Model/SelectDesignBuildCategoryModal";

export default function BidOpportunityComponent({ type }) {
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenDesignBuild, setModalOpenDesignBuild] = useState(false);
  const [requestApproved, setRequestApproved] = useState(
    JSON.parse(localStorage.getItem("loggedInUserInfo")).status_request,
  );

  const storedDashboardData =
    JSON.parse(localStorage.getItem("add_to_dashboard")) || [];
  const dashboardStatusMap = storedDashboardData.reduce((acc, item) => {
    acc[item.name] = item.status;
    return acc;
  }, {});

  const handleDesignBuildModalOpen = () => {
    setModalOpenDesignBuild(true);
  };

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => setModalOpen(false);
  const handleDesignBuildModalClose = () => setModalOpenDesignBuild(false);

  const handleRequestApproved = (status) => setRequestApproved(status);

  return (
    <div className="card w-100 bg-primary rounded-3 shadow-sm mb-4 border-0">
      <div className="card-header g-0 m-0 p-0 overflow-hidden border-bottom border-secondary border-2">
        <div className="row g-0">
          <div className="col g-0">
            <h3 className="p-3 mb-0 pb-0 point-22 text-uppercase text-white fw-bold">
              Bid Opportunities
            </h3>
          </div>
          <div className="col-auto bg-secondary">
            <div className="d-flex flex-column justify-content-center">
              <img src={bigImg} alt="icon" className="header-icon m-2" />
            </div>
          </div>
        </div>
      </div>
      <div className="card-body p-3">
        <div className="mt-4">
          <div className="row gx-2 gy-3">
              <div className="col-12 col-md-6">
                <button
                  type="button"
                  className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                  style={{ fontSize: "0.9rem" }}
                  onClick={() =>
                    navigate("/statecitycountry", {
                      state: {
                        search: {
                          value: "City",
                          label: "City",
                        },
                      },
                    })
                  }
                >
                  City
                </button>
              </div>
            <div className="col-12 col-md-6">
              <button
                type="button"
                className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                style={{ fontSize: "0.9rem" }}
                onClick={() => navigate("/dot")}
              >
                DOT
              </button>
            </div>
            {/* <div className="col-12 col-md-6">
              <button
                type="button"
                className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                style={{ fontSize: "0.9rem" }}
                onClick={() => navigate("/statecitycountry")}
              >
                State/City/County
              </button>
            </div> */}
              <div className="col-12 col-md-6">
                <button
                  type="button"
                  className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                  style={{ fontSize: "0.9rem" }}
                  onClick={() =>
                    navigate("/statecitycountry", {
                      state: {
                        search: {
                          value: "County",
                          label: "County",
                        },
                      },
                    })
                  }
                >
                  County
                </button>
              </div>
            <div className="col-12 col-md-6">
              <button
                type="button"
                className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                style={{ fontSize: "0.9rem" }}
                onClick={handleDesignBuildModalOpen}
              >
                Design Build
              </button>
            </div>
            <div className="col-12 col-md-6">
              <button
                type="button"
                className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                style={{ fontSize: "0.9rem" }}
                onClick={() => navigate("/private")}
              >
                Private
              </button>
            </div>

            {/* {dashboardStatusMap["state"] === 1 && (
              <div className="col-12 col-md-6">
                <button
                  type="button"
                  className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                  style={{ fontSize: "0.9rem" }}
                  onClick={() =>
                    navigate("/statecitycountry", {
                      state: {
                        search: {
                          value: "State",
                          label: "State",
                        },
                      },
                    })
                  }
                >
                  State
                </button>
              </div>
            )} */}
            {dashboardStatusMap["wah"] === 1 && (
              <div className="col-12 col-md-6">
                <button
                  type="button"
                  className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                  style={{ fontSize: "0.9rem" }}
                  onClick={() =>
                    navigate("/designbuild", {
                      state: {
                        category: { label: "WAH", value: "DESIGN_BUILD_WAH" },
                      },
                    })
                  }
                >
                  WAH
                </button>
              </div>
            )}
            {dashboardStatusMap["mrb"] === 1 && (
              <div className="col-12 col-md-6">
                <button
                  type="button"
                  className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                  style={{ fontSize: "0.9rem" }}
                  onClick={() =>
                    navigate("/designbuild", {
                      state: {
                        category: { label: "MRB", value: "DESIGN_BUILD_MRB" },
                      },
                    })
                  }
                >
                  MRB
                </button>
              </div>
            )}
            {dashboardStatusMap["bayway"] === 1 && (
              <div className="col-12 col-md-6">
                <button
                  type="button"
                  className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                  style={{ fontSize: "0.9rem" }}
                  onClick={() =>
                    navigate("/designbuild", {
                      state: {
                        category: {
                          label: "BAYWAY",
                          value: "DESIGN_BUILD_WAYBAY",
                        },
                      },
                    })
                  }
                >
                  BAYWAY
                </button>
              </div>
            )}
            {(type === "WAH" || type === "CCN") && (
              <div className="col-12">
                {requestApproved === "not_requested" ? (
                  <button
                    className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                    style={{ fontSize: "0.9rem" }}
                    onClick={handleModalOpen}
                  >
                    Request for Project Upload
                  </button>
                ) : requestApproved === "pending" ? (
                  <button
                    className="btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                    style={{ fontSize: "0.9rem" }}
                    disabled
                  >
                    Upload Project Request is Pending
                  </button>
                ) : (
                  <button
                    className="btn-k btn btn-outline-secondary border-3 text-secondary w-100 rounded-5 fw-bold text-uppercase"
                    style={{ fontSize: "0.9rem" }}
                    onClick={() => navigate("/add_projects")}
                  >
                    Upload Project
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Conditional Button Rendering */}
      </div>

      {/* Modals */}
      {modalOpen && (
        <UploadProjectRequestModal
          open={modalOpen}
          handleClose={handleModalClose}
          requestApproved={handleRequestApproved}
        />
      )}

      {modalOpenDesignBuild && (
        <SelectDesignBuildCategoryModal
          open={modalOpenDesignBuild}
          handleClose={handleDesignBuildModalClose}
        />
      )}
    </div>
  );
}
